module.exports = __webpack_public_path__ + "static/media/Gallery-BG.ab149062.jpg";